<template>
  <v-row no-gutters class="number-picker-container">
    <v-col class="flex-grow-0">
      <v-btn
        class="mx-2"
        fab
        outlined
        large
        color="primary"
        :disabled="!canIncrement(-1)"
        data-qa="decrement_button"
        @click="increment(-1)"
      >
        -
      </v-btn>
    </v-col>
    <v-col>
      <div class="number-control">
        <bm-number
          :value="value"
          v-bind="$attrs"
          :min="min"
          :max="max"
          @input="setValue"
        ></bm-number>
      </div>
    </v-col>
    <v-col class="flex-grow-0">
      <v-btn
        class="mx-2"
        fab
        outlined
        large
        color="primary"
        :disabled="!canIncrement(1)"
        data-qa="increment_button"
        @click="increment(1)"
      >
        +
      </v-btn>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import BmNumber from "@/components/controls/input/BmNumber.vue";
import BmInputField from "@/components/controls/input/mixins/BmInputField";
import Vue from "vue";
export default Vue.extend({
  name: "DaNumber",
  inheritAttrs: false,
  mixins: [BmInputField],
  components: { BmNumber },
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: Number,
      required: false,
    },
    min: {
      type: Number,
      default: undefined,
    },
    max: {
      type: Number,
      default: undefined,
    },
  },
  methods: {
    canIncrement(increment: number) {
      let newVal = (this.value || 0) + increment;
      return (
        newVal >= (this.min ?? Number.NEGATIVE_INFINITY) &&
        newVal <= (this.max ?? Number.POSITIVE_INFINITY)
      );
    },
    increment(increment: number) {
      if (this.canIncrement(increment)) {
        this.setValue((this.value || 0) + increment);
      }
    },
    setValue(newValue: number) {
      this.$emit("input", newValue);
    },
  },
});
</script>

<style scoped lang="sass">

.number-picker-container
  max-width: 350px

.number-control
  display: inline-block
  padding: 0 6px
  width: 100%

:deep(.v-btn--outlined)
  font-family: Nunito,sans-serif
  font-size: 32px

:deep(.v-text-field input)
  text-align: center
</style>
